export enum SurveyResultTab {
  Questions = 'questions',
  FillOuts = 'fill-outs',
  AggregatedResults = 'aggregated-results',
  PatientResults = 'patient-results',
}
